import React from 'react'
import { Dayjs } from 'dayjs'
import { useDispatch } from 'react-redux'
import { DatePickerMui } from 'src/components/DatePickerMui'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'

export const DateIntervalPicker = () => {
  const dispatch = useDispatch()
  const startDate = useSelector((state) => state.receivementOverviewList.startDate)
  const endDate = useSelector((state) => state.receivementOverviewList.endDate)

  const setStartDate = (typedStartDate?: Dayjs) => dispatch(actions.setDateInterval({ startDate: typedStartDate, endDate }))
  const setEndDate = (typedEndDate?: Dayjs) => dispatch(actions.setDateInterval({ startDate, endDate: typedEndDate }))

  return (
    <>
      <DatePickerMui
        label='Data Inicial *'
        currentValue={startDate}
        setCurrentValue={setStartDate}
        required
        maxDate={endDate}
        readOnly
        testId='start-date-picker'
      />
      <DatePickerMui
        label='Data Final *'
        currentValue={endDate}
        setCurrentValue={setEndDate}
        required
        minDate={startDate}
        disableFuture
        readOnly
        testId='end-date-picker'
      />
    </>
  )
}
